module.exports = __webpack_public_path__ + "static/media/tracker_widget.f035f305.jpg";